import styles from './Commissioner.module.css';
import plus from './plus.svg';
import minus from './minus.svg';
import { useState} from 'react';

export default function Commissioner(props) {
  const [isOpen, setIsOpen] = useState(false);

  let commissionerClasses = styles.commissioner;
  commissionerClasses += isOpen ? " " + styles.open : "";

  return (<div className={commissionerClasses}>

      <div className={styles.back}>
      <h3>{props.data.name}</h3>
        <p dangerouslySetInnerHTML={{__html: props.data.cv}}>
        </p>
      </div>
      <div className={styles.front}>
        <img src={process.env.PUBLIC_URL+  "/pictures/" + props.data.picture} alt={props.data.name + " picture"} />
        <h3>{props.data.name}</h3>
        <hr className={props.divider}/>
        <p dangerouslySetInnerHTML={{__html: props.data.summary}}></p>

      </div>

      <div className={styles.btn} onClick={()=>setIsOpen(!isOpen)}>
        <img className={styles.plus} src={plus}/>
        <img className={styles.minus} src={minus}/>
      </div>

    </div>)
}
